import Flickity from 'flickity-imagesloaded';

export default class PartnersCarousel {
  constructor() {
    this.$el = document.querySelector('.c-partners-carousel');
    if (!this.$el) return;

    this.$carouselElement = this.$el.querySelector('.c-partners-carousel__carousel:not(.has-single)');
    this.$slides = this.$el.querySelectorAll('.c-partner-card');
    
    if (this.$carouselElement) {
      this.$prevBtn = this.$el.querySelector('.js-partners-carousel-prev');
      this.$nextBtn = this.$el.querySelector('.js-partners-carousel-next');

      this.$progress = this.$el.querySelector('.js-partners-carousel-progress');

      const options = {
        imagesLoaded: true,
        contain: false,
        prevNextButtons: false,
        pageDots: false,
        groupCells: 2,
        cellAlign: 'left',
        percentPosition: false,
        arrowShape: 'M76 51.6H11v-6.8h65L54.7 23.5l4.8-4.8L89 48.2 59.5 77.7l-4.8-4.8L76 51.6z',
      };

      if (window.innerWidth <= 1024) {
        options.groupCells = 1;
        options.cellAlign = 'center';
        options.pageDots = true;
      }

      this.carousel = new Flickity(this.$carouselElement, options);

      this.carousel.on('select', () => {
        this.$prevBtn.disabled = this.carousel.selectedIndex === 0;
        this.$nextBtn.disabled = this.carousel.selectedIndex === this.carousel.slides.length - 1;
      });

      this.carousel.on('scroll', (progress) => {
        progress = Math.max(0, Math.min(1, progress));
        this.$progress.style.width = progress * 100 + '%';
      });
      

      this.$prevBtn.addEventListener('click', () => {
        this.carousel.previous();
      });

      this.$nextBtn.addEventListener('click', () => {
        this.carousel.next();
      });
    }
  }
}
